import { render, staticRenderFns } from "./borrowingRecordList.vue?vue&type=template&id=701aca42&scoped=true&"
import script from "./borrowingRecordList.vue?vue&type=script&lang=js&"
export * from "./borrowingRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701aca42",
  null
  
)

export default component.exports